module.exports = __webpack_public_path__ + "assets/let's-encrypt.89e98114.svg";